module.exports = __webpack_public_path__ + "static/media/yellow_back.28340480.png";